// extracted by mini-css-extract-plugin
export var category = "Guides-module--category--c3d48";
export var grid = "Guides-module--grid--a8483";
export var title = "Guides-module--title--931c1";